export const clients = [
  {
    'name':			'Aalto Yliopisto',
    'logo_url':	require('../assets/images/clients/Aalto-300x136.png'),
    'url':			'http://www.aalto.fi'
  },
  {
    'name':			'Ajasto',
    'logo_url':	require('../assets/images/clients/Ajasto-300x136.png'),
    'url':			'http://www.ajasto.fi'
  },
  {
    'name':			'Ajasto',
    'logo_url':	require('../assets/images/clients/AV-Arkki-300x136.png'),
    'url':			'http://www.av-arkki.fi'
  },
  {
    'name':			'Almaco',
    'logo_url':	require('../assets/images/clients/Almaco-300x136.png'),
    'url':			'http://www.almaco.cc'
  },
  {
    'name':			'Ambientia',
    'logo_url':	require('../assets/images/clients/Ambientia-300x136.png'),
    'url':			'http://www.ambientia.fi'
  },
  {
    'name':			'Boknäs',
    'logo_url':	require('../assets/images/clients/Boknas-300x136.png'),
    'url':			'https://boknas.fi/'
  },
  {
    'name':			'Carecode',
    'logo_url':	require('../assets/images/clients/Carecode-300x136.png'),
    'url':			'https://carecode.fi/'
  },
  {
    'name':			'Espoo',
    'logo_url':	require('../assets/images/clients/Espoo1-300x136.png'),
    'url':			'http://www.espoo.fi'
  },
  {
    'name':			'Evira',
    'logo_url':	require('../assets/images/clients/Evira-300x136.png'),
    'url':			'http://www.evira.fi'
  },
  {
    'name':			'Fremantle Media',
    'logo_url':	require('../assets/images/clients/FremantleMedia-300x136.png'),
    'url':			'http://www.fremantlemedia.com'
  },
  {
    'name':			'Gallen-Kallelan Museo',
    'logo_url':	require('../assets/images/clients/GallenKallelanMuseo-300x136.png'),
    'url':			'http://www.gallen-kallela.fi/'
  },
  {
    'name':			'Helsingin kaupunki',
    'logo_url':	require('../assets/images/clients/HelsinginKaupunki-300x136.png'),
    'url':			'http://www.hel.fi'
  },
  {
    'name':			'HotelF6',
    'logo_url':	require('../assets/images/clients/HotelF6-300x136.png'),
    'url':			'http://www.hotelf6.fi'
  },
  {
    'name':			'HSY',
    'logo_url':	require('../assets/images/clients/hsy-300x136.png'),
    'url':			'http://www.hsy.fi'
  },
  {
    'name':			'Kilpailu- ja kuluttajavirasto',
    'logo_url':	require('../assets/images/clients/KKV-300x136.png'),
    'url':			'http://www.kkv.fi'
  },
  {
    'name':			'KT Interior',
    'logo_url':	require('../assets/images/clients/KTinterior-300x136.png'),
    'url':			'https://ktinterior.fi/'
  },
  {
    'name':			'Marwe',
    'logo_url':	require('../assets/images/clients/Marwe-300x136.png'),
    'url':			'http://www.marwe.com'
  },
  {
    'name':			'Metropolia',
    'logo_url':	require('../assets/images/clients/Metropolia-300x136.png'),
    'url':			'http://www.metropolia.fi'
  },
  {
    'name':			'Nordkapp',
    'logo_url':	require('../assets/images/clients/Nordkapp-300x136.png'),
    'url':			'http://www.nordkapp.fi'
  },
  {
    'name':			'Rakettitiede',
    'logo_url':	require('../assets/images/clients/Rakettitiede-300x136.png'),
    'url':			'http://www.rakettitiede.fi'
  },
  {
    'name':			'Trium',
    'logo_url':	require('../assets/images/clients/Trium-300x136.png'),
    'url':			'http://www.trium.fi'
  },
  {
    'name':			'Viiittomakielialan Osuuskunta Via',
    'logo_url':	require('../assets/images/clients/VIA-300x136.png'),
    'url':			'http://www.via-ok.net'
  },
  {
    'name':			'Yle',
    'logo_url':	require('../assets/images/clients/yle1-300x136.png'),
    'url':			'http://www.yle.fi'
  }
];



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/data/ClientsData.tsx